const MarketingMaterial = () => {
  return <div>MarketingMaterial</div>;
};

export default MarketingMaterial;
